import { render, staticRenderFns } from "./relationlist.vue?vue&type=template&id=4885742b&"
import script from "./relationlist.vue?vue&type=script&lang=js&"
export * from "./relationlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports